/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/
import { Box, Stack, Typography } from "@mui/material";
import { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Link } from "@mui/material";

const MUIFileUpload = () => {
  const [fileNames, setFileNames] = useState<string[]>([]);

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      console.log("Dropped Files:", acceptedFiles);
      if (acceptedFiles.length > 0) {
        setFileNames((prev) => [...prev, ...acceptedFiles.map((file) => file.name)]);
      }
    },
    [setFileNames]
  );

  const handleRemoveFile = (fileName: string) => {
    setFileNames((prev) => prev.filter((name) => name !== fileName));
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop, multiple: true });

  return (
    <Stack spacing={3} alignItems="center" sx={{ my: 4, width: "100%" }}>
      {/* Drag and Drop Box + File List in a Column */}
      <Stack spacing={2} alignItems="center" width="100%" maxWidth={400}>
        {/* Drag and Drop Box */}
        <Box
          {...getRootProps()}
          sx={{
            width: "100%",
            border: "2px dashed gray",
            padding: 4,
            textAlign: "center",
            cursor: "pointer",
            borderRadius: 2,
          }}
        >
          <input {...getInputProps()} />
          <Typography variant="body2" sx={{ fontSize: "14px", color: "gray" }}>
            Drag & Drop files here or click to upload
          </Typography>
        </Box>

        {/* File List (Appears Below) */}
        {fileNames.length > 0 && (
          <Stack spacing={1} width="100%" textAlign="left">
            {fileNames.map((name, index) => (
              <Stack key={index} direction="row" alignItems="center" spacing={1}>
                <Typography variant="body2" sx={{ fontSize: "14px", color: "darkblue" }}>
                  {name}
                </Typography>
                <Link
                  color="error"
                  component="button"
                  sx={{ fontSize: "14px", cursor: "pointer" }}
                  onClick={() => handleRemoveFile(name)}
                >
                  Remove
                </Link>
              </Stack>
            ))}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default MUIFileUpload ;
